module.exports = __webpack_public_path__ + "static/img/309.88c760ac.jpg";